<template>
    <div>
        <h4>{{data.clerk[0].name}}</h4>
        <h5 class="mb-4 mt-2"><strong>Valor solicitado: </strong>R$ {{formatMoneyUn(data.value /100)}}</h5>
        <div>
            <b-form-select v-model="selected" :options="options"></b-form-select> <br> <br>
            <div v-if="selected == 2">
                <p class="text-danger mb-2">Digite o motivo do cancelamento*</p>
                <b-input-group prepend="Motivo" class="mb-2">
                    <b-form-input v-model="reason"></b-form-input>
                </b-input-group>
            </div>
            <div class="d-flex justify-content-between mt-5">
                <button class="btn btn-danger" @click="$bvModal.hide('status-modal')">Cancelar</button>
                <button class="btn btn-success" @click="alterStatus()">Salvar</button>
            </div>
        </div>
    </div>
</template>
<script>
import makeToast from 'Mixins/makeToast';
import CoinStatus from '../../../enums/CoinStatus';
export default {
    mixins: [makeToast],
    data() {
        return {
        CoinStatus,
        reason: 'não aprovado a solicitação de saque',
        options: [
            { value: 1, text: 'Aguardando aprovação' },
            { value: 2, text: 'Cancelado' },
            { value: 3, text: 'Finalizado' },
        ],
        selected: null,
        }
    },

    props: {
        data: {
            type: Object,
            required: true,
        },
    },

    mounted() {
        this.getData();
    },

    methods: {
        getData() {
            this.selected = this.data.status;
        },

        formatMoneyUn(value) {
            var money = parseFloat(value);
            return money.toLocaleString('pt-br', {minimumFractionDigits: 2});
        },

        alterStatus() {
            if (this.data.status == this.CoinStatus.FINALIZADO) {
                this.makeToast('Oopss', 'O status não pode ser alterado!', 'danger');
                return;
            }
            if (this.data.status == this.CoinStatus.CANCELADO) {
                this.makeToast('Oopss', 'O status não pode ser alterado!', 'danger');
                return;
            }
            if (this.selected == this.data.status) {
                this.makeToast('Oopss', 'Por favor selecionar um status diferente!', 'danger');
                return;
            }
            if (this.selected < this.data.status) {
                this.makeToast('Oopss', 'Não pode voltar para o status anterior!', 'danger');
                return;
            }
            const data = {
                'idClerk': this.data.id_clerk,
                'idStatus': this.data.id,
                'value': this.data.value,
                'phone': this.data.clerk[0].phone,
                'status': this.selected,
                'description': this.reason
            };
            this.$store.dispatch('startLoader');
            this.$store.dispatch('balconista/alterarStatus', data)
            .then((resp) => {
                if(resp.status == 200) {
                    this.makeToast('Sucesso!', resp.data.message, 'success');
                    setTimeout(() => {
                        this.$emit('update-page');
                        this.$bvModal.hide('status-modal');
                    }, 500);
                }
            })
            .catch(() => {
                this.makeToast('Oopss', 'Houve um erro ao trazer os valores!', 'danger')
            })
            .finally(() => {
                this.$store.dispatch('endLoader')
            });
            },
    }
}
</script>